import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Flexbox } from '@piconetworks/pkg-box';
import chainFunction from './chainFunction.js';

var _excluded = ["className", "children", "name", "variant", "debug", "value", "onChange", "type", "isVertical"];
var ToggleBarGroup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    name = _ref.name,
    variant = _ref.variant,
    debug = _ref.debug,
    value = _ref.value,
    onChange = _ref.onChange,
    type = _ref.type,
    isVertical = _ref.isVertical,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (debug) {
    console.log('ToggleBarGroup: debug is true', props);
  }
  var getValues = function getValues() {
    return value == null ? [] : [].concat(value);
  };
  var handleToggle = function handleToggle(inputVal, event) {
    if (debug) {
      console.log('handleToggleCalled', inputVal, event);
    }
    if (!onChange) {
      return;
    }
    var values = getValues();
    if (debug) {
      console.log('Values are', values);
    }
    var isActive = values.indexOf(inputVal) !== -1;
    if (debug) {
      console.log('inputVal:', inputVal, 'isActive:', isActive);
    }
    if (type === 'radio') {
      if (!isActive && onChange) onChange(inputVal, event);
      return;
    }
    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== inputVal;
      }), event);
    } else {
      onChange([].concat(values, [inputVal]), event);
    }
  };
  var mapOfChildren = React.Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      if (debug) {
        console.log(child, 'is a valid React element');
      }
      var values = getValues();
      var _child$props = child.props,
        childVal = _child$props.value,
        childOnChange = _child$props.onChange;
      var handler = function handler(e) {
        return handleToggle(childVal, e);
      };
      return /*#__PURE__*/React.cloneElement(child, {
        type: type,
        name: child.name || name,
        checked: values.indexOf(childVal) !== -1,
        active: values.indexOf(childVal) !== -1,
        disabled: child.props.disabled,
        className: cx(values.indexOf(childVal) !== -1 && 'active', variant && "btn-toggle-" + variant, child.props.className),
        debug: debug,
        onChange: chainFunction(childOnChange, handler)
      });
    } else {
      console.log('Pass only valid react elements to this group if this is a selectable toggle bar item', child);
      return child;
    }
  });
  return /*#__PURE__*/React.createElement(Flexbox.Container, _extends({
    className: cx(className, 'btn-group', 'btn-group-toggle', isVertical && 'btn-group-vertical'),
    flexDirection: isVertical ? 'column' : 'row',
    role: "group",
    ref: ref
  }, props), mapOfChildren);
});
ToggleBarGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  debug: PropTypes.bool,
  isVertical: PropTypes.bool,
  /**
   * Callback fired when a button is pressed with the new value
   */

  /**
   * An HTML `<input>` name for each child button.
   */
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons. Just doing radio for now.
   */
  type: PropTypes.string,
  /**
   * The value selected
  */
  value: PropTypes.any,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link'])
};
ToggleBarGroup.displayName = 'ToggleBarGroup';
ToggleBarGroup.defaultProps = {
  debug: false,
  type: 'radio'
};

export { ToggleBarGroup as default };
//# sourceMappingURL=Group.js.map
